import { EventEmitterFactory } from 'pf-frontend-common/src/module/event/emitter.factory';
import { WindowService } from 'pf-frontend-common/src/service/window/service';

import { PreactView } from 'common/module/preact/view';
import { TextTrimControlsTemplate } from 'common/module/text-trim/controls/template';
import { TextTrimControlsViewStore } from 'common/module/text-trim/controls/view-store';
import { TextTrimView } from 'common/module/text-trim/view';

export function TextTrimViewFactory(): TextTrimView {
  return new TextTrimView(
    WindowService(),
    EventEmitterFactory(),
    new PreactView(TextTrimControlsTemplate, new TextTrimControlsViewStore(EventEmitterFactory()))
  );
}
